import { BASE_COLORS } from "components/Global/ColorPicker/ColorChart/constants";

export default () => {
  const colors = BASE_COLORS.filter(c => c.autoselectable);
  return colors[Math.floor(Math.random() * colors.length)].backgroundColor;
};
